import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingBox from '../../../../components/LoadingBox';
import { PlanProvider } from "../../../../contexts/PlanOperationContext/Plan";
import { selectPermissions } from "../../../../util/store/selectors";
import { getMondayByKey, getSundayByKey, jumpToTarget } from "../../../../util/varibles/global";
import { ACTION } from '../../../../util/varibles/permission';
import Menu from '../../_components/Menu';
import { CALENDAR_ID, selectPlan } from "../../constants";
import { planOpActions } from "../../reducer";
import { HEIGHT_PER_DAY } from "./Operations/constants";
import InvoiceRelationLines from './InvoiceRelationLines';
import styles from './style.module.scss';
import Vessels from "./Vessels";
import Weeks from "./Weeks";

const Calendar: React.FC = () => {
    const weeks = useSelector(selectPlan.weeks);
    const loading = useSelector(selectPlan.loadingVessels);
    const startTime = getMondayByKey(weeks[0]).time;
    const finishTime = getSundayByKey(weeks[weeks.length - 1]).time;
    const calendarRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch()
    const [canUseVesselMenu, canUseOperationMenu, canUpdateOperation] = useSelector(selectPermissions([
        ACTION.PLAN_OP.VESSEL_MENU,
        ACTION.PLAN_OP.OP_MENU,
        ACTION.PLAN_OP.UPDATE_OP,
    ]));

    useEffect(() => {
        setTimeout(() => jumpToTarget(CALENDAR_ID), 200);
    }, [])

    return <div className="relative h-full w-full" aria-busy={loading}>
        <div ref={calendarRef} id={CALENDAR_ID} className={styles.calendar} style={{ '--begin': startTime, '--height-day': `${HEIGHT_PER_DAY}px` } as any}>
            <Weeks startTime={startTime} finishTime={finishTime} />
            <PlanProvider
                startCalendar={startTime}
                endCalendar={finishTime}
                calendarRef={() => calendarRef.current as HTMLDivElement}
                onDragOp={params => dispatch(planOpActions.dragOperation(params))}
                permission={{
                    VESSEL_MENU: canUseVesselMenu,
                    OP_MENU: canUseOperationMenu,
                    UPDATE_OP: canUpdateOperation,
                }}
            >
                <Menu>
                    <Vessels />
                </Menu>
                <InvoiceRelationLines calendarRef={calendarRef} />
            </PlanProvider>
        </div>
        {loading && <LoadingBox loading level="bg" />}
    </div>
};

export default Calendar;
